require('@babel/polyfill'); // no need in homepage
require('intersection-observer'); // test without
require('url-search-params-polyfill'); // WTF
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

require('../../../static/default/lib/jquery.sticky-kit.min.js'); // pdp and cart, no needed in homeoage

$(document).ready(function () {
    processInclude(require('./components/cartMerged'));
    processInclude(require('./components/spinner'));
    processInclude(require('./components/header'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('base/components/cookie'));
    // something we used before, probably nolonger used
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('org/components/backtotop'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('org/components/clientSideValidation')); // no neede in homepage
    processInclude(require('org/components/carousels'));
    processInclude(require('org/components/vhFix'));
    processInclude(require('org/product/quickView'));
    // WHY THIS!!!!!  Bootstrap takes care of this....Maybe remove in hompage only
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/promoDrawer'));
    processInclude(require('./components/fyl')); // no needed in homega
});

require('./thirdParty/bootstrap');
require('svg4everybody')(); // test to remove in homepage
require('slick-carousel');
require('picturefill'); // test to remove in homepage
require('lazysizes'); // test to remove in homepage
